import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import i18next from 'i18next'
import i18nextXHR from 'i18next-xhr-backend'
import config from '../../../config.client.js'
import Loading from '../Loading'

import * as accountActions from '../../ducks/account'

class TranslationInitContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoading: true
    }
  }

  componentWillMount() {
    i18next.use(i18nextXHR).init(
      {
        lng: this.props.currentLanguage,
        fallbackLng: false,
        backend: {
          allowMultiLoading: false,
          loadPath: config.apiUrl + 'translations/{{lng}}',
          crossDomain: false
        }
      },
      () => this.setState({ isLoading: false })
    )
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.currentLanguage !== nextProps.currentLanguage) {
      this.setState({ isLoading: true })

      i18next.changeLanguage(nextProps.currentLanguage, () => this.setState({ isLoading: false }))
    }
  }

  render() {
    return (
      <Loading isReady={!this.state.isLoading}>
        <div key={this.props.currentLanguage}>{this.props.children}</div>
      </Loading>
    )
  }
}

function mapStateToProps(state) {
  return {
    currentLanguage: state.account.get('currentLanguage')
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(accountActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TranslationInitContainer)



// WEBPACK FOOTER //
// ./src/components/smart/TranslationInitContainer.js